module.exports = __webpack_public_path__ + "static/media/diablo.9b83a645.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/diablo.png
// module id = 144
// module chunks = 0